import { createContext, useContext } from "react";

import type { loadSpenderPage } from "~/routes/fsastore-spender/spender-page.server";

export type SpenderData = Pick<
  Awaited<ReturnType<typeof loadSpenderPage>>,
  | "shopperDeadlines"
  | "chips"
  | "categories"
  | "initialGrid"
  | "skeletonRows"
  | "asOf"
> &
  // COM-893: optional so test fixtures and older callers need not set it.
  Partial<Pick<Awaited<ReturnType<typeof loadSpenderPage>>, "plpInlineSetup">>;

export interface Spender {
  data: SpenderData;
  balance: number | null;
  setBalance: (cents: number) => void;
  clearBalance: () => void;
  /** False until a persisted balance is read back, so the card never flashes the prompt. */
  restored: boolean;
  dismissed: boolean;
  setDismissed: (dismissed: boolean) => void;
}

export const SpenderContext = createContext<Spender | null>(null);

/** Null outside the FSA Spender page: every spender block renders nothing there. */
export const useSpender = () => useContext(SpenderContext);
